export const bootBoxTitles = ["Change Rule Type?","ChangeRating Level?", "Stop A/B test", "Change Category?"];
